import styled from 'styled-components';
import { IButton } from '../button/interface/Button.interface';

const Button = styled.button`
  border: none;
  padding: 10px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 18px;
  margin: 4px 2px;
  cursor: pointer;

  width: ${ ({ block }: IButton) => (block) ? '100%' : 'auto' };
`;

export default Button;
